<!------------------------------------------------------------------------------
 File: BaseNavListItem 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 17/10/2018
 Time: 16:12
------------------------------------------------------------------------------->
<template>
    <a
        class="base-nav--list-item"
        :href="event_uri"
    >
        <span class="d-flex align-items-center "
              :class="{
                'justify-content-between':direction !== 'ltr' && direction !== 'rtl',
                'justify-content-end':direction === 'rtl',
                'justify-content-start':direction === 'ltr'
            }"
        >
            <BaseIcon
                v-if="direction == 'ltr'"
                class="mr-2"
                :cls="icon.cls">{{icon.content}}
            </BaseIcon>

            <slot></slot>
            <span class="text-nowrap">{{content_small}} <span
                class="d-none d-md-inline">{{content_large}}</span></span>

            <BaseIcon
                v-if="direction == 'rtl'"
                class="ml-2"
                :cls="icon.cls">{{icon.content}}
            </BaseIcon>

        </span>
    </a>
</template>

<script>
    export default {
        name: 'baseNavListItem',
        components: {},
        props: {
            event_uri: String,
            content_small: String,
            content_large: String,
            icon: {
                content: {
                    type: String,
                    default: ''
                },
                cls: {
                    type: String,
                    default: 'material-icons'
                }
            },
            direction: {
                type: String,
                default: 'ltr'
            }
        },
        created() {},
        destroyed() {},
        mounted() {

        },
        data() {
            return {};
        },
        methods: {},
        watch: {},
        computed: {}
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/base/BaseNavListItem.vue?4d9dc0d0